import React, { Component } from "react";
import Image from "../../../../../../components/ZUILib/Image";
import commonUtil from "../../../../../../utils/commonUtil";

import * as defaultConst from "../../../../../../utils/clientConstant";

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];

class Template1 extends Component {
  render() {
    const { giftDetail, eventContractInfo } = this.props;

    const selectedGiftDetail = {...giftDetail};

    const giftImageSrc = [
      {
        media: "(max-width: 465px)",
        srcSet: giftDetail.imageURL,
      },
    ];

    const isGiftCertificate = this.props.giftDetail.categoryName === "Gift Certificate" || this.props.giftDetail.categoryName === "Certificado Electrónico";
    const giftImageAttribute = {
      className: isGiftCertificate ? "thumbGiftCertificate" : "thumb",
      id: "img1",
      alt: "Liverpool",
      src: giftDetail.imageURL,
      altImg: giftDetail?.altImageUrl || commonUtil.getAssetURL() + "/images/guest/no-image.png",
    };

    //---------------------
    let messageLabel = "";
    let messageIconName = "";

    if (giftDetail.messageInfo === "new") {
      messageLabel = commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.regalosrecibidos.message.newmsg");
      messageIconName = "icon-new-message";
    }
    if (giftDetail.messageInfo === "replied") {
      messageLabel = commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.regalosrecibidos.message.ansmsg");
      messageIconName = "icon-answered";
    }

    if (giftDetail.messageInfo === "opened") {
        messageLabel = commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.regalosrecibidos.message.readmsg");
        messageIconName = "icon-read";
    }

    if (giftDetail.messageInfo === "none") {
        messageLabel = commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.regalosrecibidos.message.nomsg");
        messageIconName = "icon-no-message";
    }

    selectedGiftDetail.messageLabel = messageLabel;
    selectedGiftDetail.messageIconName = messageIconName;
    //-------------------------------
     let messageStatusImage = "";
/*
   
    let messageIconName = "";
    if (giftDetail.messageInfo === "new") {
      messageStatusImage = commonUtil.getAssetURL() + "/images/gifts/new.png";
      messageIconName = commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalosrecibidos.message.newmsg"
      );
    }

    if (giftDetail.messageInfo === "replied") {
      messageStatusImage =
        commonUtil.getAssetURL() + "/images/gifts/delivered.png";
      messageIconName = commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalosrecibidos.message.ansmsg"
      );
    }

    if (giftDetail.messageInfo === "opened") {
      messageStatusImage = commonUtil.getAssetURL() + "/images/gifts/read.png";
      messageIconName = commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalosrecibidos.message.readmsg"
      );
    }

    if (giftDetail.messageInfo === "none") {
      messageStatusImage = commonUtil.getAssetURL() + "/images/gifts/none.png";
      messageIconName = commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.regalosrecibidos.message.nomsg"
      );
    }

    /* For Message Icon */

    const imageSrcForMessage = [
      {
        media: "(max-width: 465px)",
        srcSet: messageStatusImage, //
      },
    ];
    const imageAttributeForMessage = {
      id: "img1",
      alt: "Liverpool",
      src: messageStatusImage, // messageStatusImage
    };

    if (commonUtil.isEmpty(giftDetail) || giftDetail === undefined) {
      // TODO: Need to check abt guestInfo. some time service give this data some time does not give it
      return null;
    }
    const giftPrice = commonUtil.getCurrency(giftDetail.price);
        const [giftPriceWhole, giftPricecents] = giftPrice?.split('.') ?? ['', ''];
      const giftPriceFormatted = (
        <>
        <span className="amount">{giftPriceWhole}</span><sup className="decimal">{giftPricecents}</sup>
        </>
      );

    const giftSection = "RecibidosSection";
    return (
      <tr>
        <td>
          <Image imageAttr={giftImageAttribute} _imgsrc={giftImageSrc} />
        </td>
        <td>
          <div className="headTitle">{giftDetail.displayName}</div>
          {giftDetail.actionType !== "purchase" ? (
            <div className="price">{giftPriceFormatted}</div>
          ) : (
            <div className="price">{giftPriceFormatted}</div>
          )}
          <div className="quantity">
            <strong>{commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.qty.label"
            )}</strong>
            : {giftDetail.quantity}
          </div>
          <div className="guest">
            <span>
              {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.delivery.address.invited.label"
            )}
            </span>
            : <span>{giftDetail?.guestInfo?.name ?? commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.guest.name")}{" "}</span>
          </div>

           {giftDetail.modeofDelivery === "physical" ? (
                <div className="tag tag-electronic"><span className="icon-home"></span>Regalo Físico</div>
              ) : (
               <div className="tag tag-electronic"><span className="icon-monetization_on"></span>Regalo electrónico</div>
              )}{" "}


          {
            (
              <React.Fragment>
                {this.props.compareEventStatus(giftDetail.deliveryStatus, "store.delivery.message") ? (
                  <div className="tag statusDeliverToStore">
                    {/* Entregado en tienda */}
                    <span className="icon-circle"></span>
                    {commonUtil.getLabel(this.props.lables.EventAdminPage, giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                  </div>
                ) :
                  this.props.compareEventStatus(giftDetail.deliveryStatus, "physical.delivery.message") ? (
                    <div className="tag statusDeliverToStoreGreen">
                      {commonUtil.getLabel(this.props.lables.EventAdminPage, giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                    </div>
                  ):
                  this.props.compareEventStatus(giftDetail.deliveryStatus, "electronic.delivery.message") ? (
                    <></>
                  ) : giftDetail.deliveryStatus ? (
                    <div className={`tag ${giftDetail.actionType === "returnReinvested" ? "tag-reinvested" : "tag-return"}`}>
                      <span className="icon-circle"></span>
                      {commonUtil.getLabel(this.props.lables.EventAdminPage, giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                    </div>
                  ): null}
              </React.Fragment>
            )
            // modalButton
          }

          { (eventContractInfo && eventContractInfo.bonus > 0) && this.props.eventType !== defaultConst.eventType.Others ? (
            <div className="extra">
              {commonUtil.getLabel(
                this.props.lables.EventAdminPage,
                "adminpage.regalosrecibidos.bonus.label"
              )}
              &nbsp;&nbsp;&nbsp;
              {giftDetail.bonusInfo === "true" ? (
                <i className="icon-check confirmCheck" aria-hidden="true" />
              ) : (
                  'x'
              )}{" "}
            </div>
          ) : (
            ""
          )}
          { (eventContractInfo && eventContractInfo.bonus > 0) && this.props.eventType === defaultConst.eventType.Others &&
            <div className="extra">
              {commonUtil.getLabel(
                this.props.lables.EventAdminPage,
                "adminpage.comparas.bonus.label"
              )}
              &nbsp;&nbsp;
                x
            </div>
            }
          {!(giftDetail.deliveryStatus === 'return.reinvested.delivery.message' || giftDetail.deliveryStatus === 'return.delivery.message' || giftDetail.deliveryStatus === 'cancel.delivery.message') && (
            <div className="message">
              <span className={messageIconName}></span>  {messageLabel}
            </div>
          )}

        </td>
        <td
          onClick={() =>
            this.props.selectedProductForPreview(selectedGiftDetail, giftSection)
          }
        >
          <a className="productDetail">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
              <path d="M1.70492 0.5L0.294922 1.91L4.87492 6.5L0.294922 11.09L1.70492 12.5L7.70492 6.5L1.70492 0.5Z" fill="#767676" />
            </svg>
          </a>
        </td>
      </tr>
    );
  }
}

export default Template1;
